import * as React from "react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

// Deck KPI tile: label + big tight tabular number + optional delta/hint.
// `tone` colors the number for semantic emphasis (deck: red/green/amber/coral/brand).
const toneText = {
  default: "text-foreground",
  brand: "text-primary",
  success: "text-success",
  warning: "text-warning",
  coral: "text-coral",
  danger: "text-danger",
};

const StatTile = React.forwardRef(
  ({ className, label, value, hint, icon: Icon, tone = "default", delta, deltaTone, ...props }, ref) => (
    <Card ref={ref} hover className={cn("p-5", className)} {...props}>
      <div className="flex items-start justify-between gap-3">
        <span className="text-[13px] font-medium text-muted-foreground">{label}</span>
        {Icon ? (
          <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary-tint text-primary [&>svg]:size-[18px]">
            <Icon />
          </span>
        ) : null}
      </div>
      <div className={cn("mt-2 deck-kpi text-[2rem]", toneText[tone] || toneText.default)}>{value}</div>
      {(hint || delta) && (
        <div className="mt-1 flex items-center gap-2 text-[13px]">
          {delta != null && (
            <span
              className={cn(
                "font-semibold",
                deltaTone === "down" ? "text-danger" : deltaTone === "up" ? "text-success" : "text-muted-foreground"
              )}
            >
              {delta}
            </span>
          )}
          {hint && <span className="text-muted-foreground">{hint}</span>}
        </div>
      )}
    </Card>
  )
);
StatTile.displayName = "StatTile";

export { StatTile };
